// Central brand + contact config — edit here to update site-wide content (CMS-ready)
export const SITE = {
  name: "Vruksha Valley",
  fullName: "Vruksha Valley Eco Resort",
  tagline: "Escape Into The Mist",
  location: "Kalasa · Western Ghats · Chikkamagaluru",
  phone: "08217764481",
  phone2: "+91 63643 64481",
  phone2Intl: "+916364364481",
  email: "vrukshavalley@gmail.com",
  phoneIntl: "+918217764481",
  whatsapp: "918217764481",
  googleReviews: "https://www.google.com/maps/place/Vruksha+Valley/@13.2392034,75.3305416,17z/data=!4m18!1m9!3m8!1s0x3bbb497b5652598b:0x1d33fa62d792d25d!2sVruksha+Valley!8m2!3d13.2392034!4d75.3331165!9m1!1b1!16s%2Fg%2F11ytl6sq7s!3m7!1s0x3bbb497b5652598b:0x1d33fa62d792d25d!8m2!3d13.2392034!4d75.3331165!9m1!1b1!16s%2Fg%2F11ytl6sq7s?entry=ttu",
  agency: "https://smartmarketingchikmagalur.netlify.app",
  instagram: "https://www.instagram.com/vrukshavalley?igsh=eGRpNTZvcXpkY3ow&utm_source=qr",
  address: "Soormane Fls Rd, Guddemakki, Kalasa, Karnataka 577124",
  plusCode: "68QM+M6 Kalasa, Karnataka",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Vruksha+Valley+Eco+Resort+Kalasa",
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/mjblphdr_Vruksha%20Valley%20-%20Logo%20PNG%202.webp",
  heroVideo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_5dd34c9f-6dff-45ce-a6d1-857af95232c8/artifacts/2dxvwolh_hero%20section.mp4",
  heroImage: "https://customer-assets-m6fa6gv7.emergentagent.net/job_5dd34c9f-6dff-45ce-a6d1-857af95232c8/artifacts/4whvboid_image%20no1.png",
  aboutImage1: "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/bxz0ez9o_about%20us.jpeg",
  aboutWelcome1: "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/nvjpxu7j_about%20us%201.jfif",
  aboutWelcome2: "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/92uie313_about%20us%202.jfif",
  aboutImage2: "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/s3mjv4zi_4.jfif",
  poolVideo: "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/wjiw658a_drone%203.webm",
  poolImage: "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/brpn7t9e_swimming%20pool.jfif",
};

export const bookingMessage = "Namaste! I would like to book a stay at Vruksha Valley Eco Resort. Could you share availability and tariff details?";

export const waLink = (msg = bookingMessage) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg)}`;

export const telLink = `tel:${SITE.phoneIntl}`;

export const EXPERIENCE_LINKS = [
  { label: "Swimming Pool", to: "/experiences/pool" },
  { label: "Malnad Food", to: "/experiences/food" },
  { label: "Campfire & Bonfire", to: "/experiences/campfire" },
  { label: "Games & Activities", to: "/experiences/games" },
  { label: "Nearby Attractions", to: "/experiences/nearby" },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Legacy", to: "/legacy" },
  { label: "Stay", to: "/stay" },
  { label: "Experiences", dropdown: EXPERIENCE_LINKS },
  { label: "Gallery", to: "/gallery" },
  { label: "Reviews", to: "/reviews" },
  { label: "Contact", to: "/contact" },
];
